export const videoType = 'video';
export const imageType = 'image';
export const bannerType = 'banner';
